let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("7zMjZ"), load("a1dBM"), load("kN6MR")]).then(() => parcelRequire('61q45'));